var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 4C0.5 3.68934 0.75184 3.4375 1.0625 3.4375H7.5795L5.16475 1.02275C4.94508 0.803078 4.94508 0.446922 5.16475 0.227252C5.38442 0.00758171 5.74058 0.00758171 5.96025 0.227252L9.33525 3.60225C9.55492 3.82192 9.55492 4.17808 9.33525 4.39775L5.96025 7.77275C5.74058 7.99242 5.38442 7.99242 5.16475 7.77275C4.94508 7.55308 4.94508 7.19692 5.16475 6.97725L7.5795 4.5625H1.0625C0.75184 4.5625 0.5 4.31066 0.5 4Z",
    fill: "#023047"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightShort);
export default __webpack_public_path__ + "static/media/arrow-right-short.176779b3576c8445ba584bb035de4a1c.svg";
export { ForwardRef as ReactComponent };